export const routes = (parentName) => {
  return [
    {
      path: "time-line",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-TimeLine`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-TimeLine-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "TimeLine-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "TimeLine-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
